import { ReactComponent as IconInfo } from '@/assets/svgs/information-circle-colored.svg';
import { ReactComponent as WhatsNew } from '@/assets/svgs/whats-new-default.svg';
import Button from "@/components/Button";
import CardConfigure from "@/components/CardConfigure/index";
import Modal from "@/components/Modal";
import useModal from "@/hooks/use-modal";
import rem from "@/utils/rem";
import PropTypes from 'prop-types';
import { useEffect, useState } from "react";
import MultiClamp from 'react-multi-clamp';
import useWhatsNew from "../../hooks/use-whatsnew/index";


const Page = ({ showWhatsNew, setShowWhatsNew }) => {
	const { visible: visiblePopup, show: showPopup, hide: hidePopup } = useModal();
	const [countStep, setCountStep] = useState(1);
	const { fetch: getFeatures, accept: acceptFeatures } = useWhatsNew();
	const [dotsButton, setDotsButton] = useState([]);
	const [features, setFeatures] = useState([]);
	const [activeData, setActiveData] = useState();


	useEffect(async () => {
		if (showWhatsNew === true) {
			const [error, whatsNew] = await getFeatures();
			setCountStep(1);
			setFeatures(whatsNew.features);
			setActiveData(whatsNew.features[0]);
			showPopup();
			setShowWhatsNew(false);
			setActiveDot(0, whatsNew.features);

			let profile = JSON.parse(sessionStorage.getItem("profile"));
			profile = { ...profile, whatsNewId: whatsNew.id };
			await acceptFeatures({ id: profile.id, whatsNewId: whatsNew.id });
			sessionStorage.setItem("profile", JSON.stringify(profile));
		}
	}, [showWhatsNew]);

	function handleFeatures(count) {
		setActiveData(features[count - 1]);
		setActiveDot(count - 1, features);
	}

	const handleNext = () => {
		setCountStep(countStep + 1);
		handleFeatures(countStep + 1)
	};

	const handlePrevious = () => {
		setCountStep(countStep - 1);
		handleFeatures(countStep - 1)
	}

	const handleToggle = (key) => {
		setCountStep(key + 1);
		handleFeatures(key + 1)
	}

	const setActiveDot = (index, featuresRow) => {
		let dots = featuresRow.map(_ => 'inactive');
		dots[index] = 'active';
		setDotsButton(dots);
	}

	return (
		<Modal visible={visiblePopup} addClass={"card-feature__new"}>
			<CardConfigure
				style={{ width: rem(660), position: 'relative' }}
				addHeaderClass="modal-template__header_divider"
			>
				<CardConfigure.Header>
					<CardConfigure.Header.Icon type={'false'}>
						<div className="card-feature__new__header_icon">
							<IconInfo />
						</div>
					</CardConfigure.Header.Icon>
					<CardConfigure.Header.Title>
						<div className="card-configure__new__header">
							<div className="card-configure__new__header_subTitle">
								What's New :
							</div>&nbsp;
							<div className="card-configure__new__header_subTitle">
								{activeData?.heading}
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>

				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="card-features__new__body_main">
							<div className="left">
								{activeData?.image === "/" ? (<WhatsNew />) : (
									<img alt="feature" className="card-features__body__left__image" src={activeData?.image} />
								)}
							</div>
							<div className="right">
								<div className="subTtitle">
									<MultiClamp clamp={2}>{activeData?.subheading}</MultiClamp>
								</div>
								<div className="content">
									{activeData?.body &&
										activeData.body.map((item, key) => (
											<div style={{ overflow: "auto" }} key={"key_" + key}>{item}</div>
										))}
								</div>
							</div>
						</div >
					</CardConfigure.Body.Col>
					<CardConfigure.Body.Col>
						{features?.length > 1 && features.map((_item, key) => (
							<div
								className={`newfeatures-radio_class ${dotsButton[key]} ${key}`}
								key={"key_" + key}
								name="nextfeature"
								onClick={() =>
									handleToggle(key)
								}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										handleToggle(key + 1);
									}
								}}
								tabIndex={key}
								role="button"
								aria-label="Next Feature"
								data-testid={`newfeatures-radio_${key}`}
							/>
						))}
					</CardConfigure.Body.Col>
				</CardConfigure.Body>

				<CardConfigure.Footer>
					<CardConfigure.Footer.Left>
						<Button
							type="button"
							full
							ghost
							round
							noborder
							maxWidth="140"
							id="cancelFeaturesButton"
							text="Cancel"
							submit={() => hidePopup()}
						/>
					</CardConfigure.Footer.Left>
					<CardConfigure.Footer.Right>< div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
						{features && countStep > 1 && (
							<Button
								type="button"
								full
								ghost
								round
								noborder
								maxWidth="140"
								id="prevFeaturesButton"
								text="Previous"
								submit={() => handlePrevious()}
							/>
						)}

						{features && countStep !== features.length && (
							<Button
								type="button"
								full
								round
								maxWidth="140"
								id="nextFeaturesButton"
								text="Next"
								submit={() => handleNext()}
							/>
						)}

						{countStep === features.length && (
							<Button
								full
								round
								maxWidth="140"
								text="Ok Got it"
								id="closeFeaturesButton"
								submit={() => hidePopup()}
							/>
						)}
					</div >
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	);
};

Page.propTypes = {
	setShowWhatsNew: PropTypes.func,
	showWhatsNew: PropTypes.bool
}

Page.defaultProps = {
	showWhatsNew: false
}

export default Page;
